import { Button } from '@mui/material';
import {
  useCompanySelectorBar,
  useUpdateAlertModal,
  useGenerateInvoiceModal,
  useAutomaticInformationModal
} from 'src/modules/SaldoView/components/CompanySelectorBar/components/hooks';
import { useFormState } from 'react-final-form';
import { type SelfFundedAccount } from 'src/shared/types/company';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';

type ActionsBarProps = {
  account: SelfFundedAccount;
  hasDirectDebitIban: boolean;
};

export const ActionsBar = ({ account, hasDirectDebitIban }: ActionsBarProps) => {
  const handleOpenViewModal = useCompanySelectorBar();
  const handleOpenAlertModal = useUpdateAlertModal();
  const handleOpenGenerateInvoiceModal = useGenerateInvoiceModal();
  const handleOpenAutomaticInformationModal = useAutomaticInformationModal();
  const { values } = useFormState();
  const { t } = useTranslation('overview');

  return (
    <Grid2 container spacing={2}>
      <Grid2>
        <Button variant="outlined" onClick={handleOpenGenerateInvoiceModal(values.selectedCompany)}>
          {t('self funding.generate invoice')}
        </Button>
      </Grid2>
      {hasDirectDebitIban && (
        <Grid2>
          <Button variant="outlined" onClick={handleOpenAutomaticInformationModal(values.selectedCompany)}>
            {t('self funding.automatic recharge')}
          </Button>
        </Grid2>
      )}
      <Grid2>
        <Button variant="outlined" onClick={handleOpenViewModal(values.selectedCompany, account)}>
          {t('self funding.manual recharge')}
        </Button>
      </Grid2>
      <Grid2>
        <Button variant="outlined" onClick={handleOpenAlertModal(values.selectedCompany, account)}>
          {t('self funding.edit treshhold')}
        </Button>
      </Grid2>
    </Grid2>
  );
};
